import Logo from '/img/main/logo.png';
import LogoMobile from '/img/main/logo-mobile.png?date=20260313';
import PartnerText from '/img/main/partner-text.png';
import ParticipateInfo from '/img/main/participation-info.png';
import ParticipateInfoActive from '/img/main/participation-info-active.png';
import SnsIcon1 from '/img/sns-icon1.png';
import SnsIcon2 from '/img/sns-icon2.png';
import SnsIcon3 from '/img/sns-icon3.png';
import SnsIcon4 from '/img/sns-icon4.png';
import GuideImg1 from '/img/guide/guide-img1.png';
import GuideImg2 from '/img/guide/guide-img2.png';
import GuideImg3 from '/img/guide/guide-img3.png';
import GuideImg4 from '/img/guide/guide-img4.png';
import NumberIcon1 from '/img/guide/number-icon1.png';
import NumberIcon2 from '/img/guide/number-icon2.png';
import NumberIcon3 from '/img/guide/number-icon3.png';
import NumberIcon4 from '/img/guide/number-icon4.png';
import Card from '/img/main/card.png?date=20260313';
import CardPc from '/img/main/card-pc.png?date=20260313';
import Check from '/img/check.png';
import CheckActive from '/img/check-active.png';
import QuestionIcon from '/img/main/question-icon.png';
import CloseIcon from '/img/close.png';
import WebFlareImage from '/img/main/web-flare.png';
import ShowDownApp from '/img/main/showdown-app.png';
import UnionIcon from '/img/main/union-icon.png';
import PartnerIcon from '/img/main/partner.png';
import KakaoIcon from '/img/main/kakao-icon.png';
import ArrowRightIcon from '/img/guide/arrow-right-icon.png';
import TicketActive from '/img/main/participation-info-active.png';
import TicketActivePc from '/img/main/participation-info-active-pc.png';
import TicketInActive from '/img/main/participation-info.png';
import TicketInActivePc from '/img/main/participation-info-pc.png';
import UsedStamp from '/img/main/stamp.png';
import CardMainWithUse from '/img/main/card-main-with-use.png?date=20260313';
import CardMainWithUsePc from '/img/main/card-main-with-use-pc.png?date=20260313';
import Delete from '/img/modal/delete.png';
import CloseWhite from '/img/modal/close-white.png';
import Location from '/img/location.png';

export const ImageUtils = {
  Logo,
  LogoMobile,
  PartnerText,
  ParticipateInfo,
  ParticipateInfoActive,
  SnsIcon1,
  SnsIcon2,
  SnsIcon3,
  SnsIcon4,
  GuideImg1,
  GuideImg2,
  GuideImg3,
  GuideImg4,
  NumberIcon1,
  NumberIcon2,
  NumberIcon3,
  NumberIcon4,
  Card,
  CardPc,
  Check,
  CheckActive,
  QuestionIcon,
  CloseIcon,
  WebFlareImage,
  ShowDownApp,
  UnionIcon,
  PartnerIcon,
  KakaoIcon,
  ArrowRightIcon,
  TicketActive,
  TicketInActive,
  TicketActivePc,
  TicketInActivePc,
  UsedStamp,
  CardMainWithUse,
  CardMainWithUsePc,
  Delete,
  CloseWhite,
  Location,
};
